<template lang="pug">
  div(:id="id")
</template>
<script>
import events from "./events.js";
import methods from "./methods.js";
import {
    camelize
} from "../utils/helper";

const directives = {};

function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item) && item !== null);
}
const merge = function(target, source) {
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach(key => {
            if (isObject(source[key])) {
                if (!target[key] || !isObject(target[key])) {
                    target[key] = source[key];
                }
                merge(target[key], source[key]);
            } else {
                Object.assign(target, {
                    [key]: source[key]
                });
            }
        });
    }
    return target;
}
const dbg = console.log;
const baseLayout = {
    hovermode: "closest",
    hoverlabel: {
        bgcolor: "#FFF"
    },
    legend: {
        y: 1,
        x: 1,
        xanchor: 'right',
        font: {
            color: 'black'
        }
    },
    margin: {
        autoexpand: false,
        l: 0,
        r: 0,
        b: 30,
        t: 2,
        pad: 0,
    },
    xaxis: {
        color: '#444'
    },
    yaxis: {
        color: '#444'
    },
    zaxis: {
        color: '#444'
    },
    paper_bgcolor: '#ffffff',
    colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf', "#e0884b","#0080f1","#d35fd3","#29d8d7","#6b9842","#73a9b4","#1c883d","#808080","#4342dd","#e84130"],
    scene: {
        xaxis: {
            zeroline: false
        },
        yaxis: {
            zeroline: false
        },
        zaxis: {
            zeroline: false
        },
    }
}
if (typeof window !== "undefined") {
    //directives.resize = require("vue-resize-directive");
}
export default {
    name: "plotly",
    inheritAttrs: false,
    directives,
    props: {
        data: {
            type: Array
        },
        layout: {
        type: Object
        },
        annotations: {
            type: Number
        },
        redraw: {
            type: Boolean
        },
       editable: {
          type: Boolean,
          required: false
        },
        setstyle: {
            type: Object,
            required: false
        },
        modeBarButtons: {
            type: Array,
            required: false
        },
        scene: {
            type: Object,
            required: false
        },
        theme: {
            type: String,
            required: false,
            default: 'dark'
        },
        id: {
            type: String,
            required: false,
            default: null
        }
    },
    data() {
        return {
            lastmode: undefined,
            scheduled: null,
            innerLayout: merge(baseLayout, this.layout),
            plotlyThemes: {
                dark2d:{
                    'paper_bgcolor': '#181818',
                    'plot_bgcolor': '#181818',
                    colorway: ["rgb(76,114,176)", "rgb(221,132,82)", "rgb(85,168,104)", "rgb(196,78,82)", "rgb(129,114,179)", "rgb(147,120,96)", "rgb(218,139,195)", "rgb(140,140,140)", "rgb(204,185,116)", "rgb(100,181,205)", "#e0884b","#0080f1","#d35fd3","#29d8d7","#6b9842","#73a9b4","#1c883d","#808080","#4342dd","#e84130"],
                        xaxis: {
                            color: "#ffffff55",
                            zeroline: true,
                            linecolor: "#ffffff00",
                            zerolinecolor: "#ffffff12",
                            gridcolor: "#ffffff08",
                        },
                        yaxis: {
                            color: "#ffffff55",
                            zeroline: true,
                            linecolor: "#ffffff00",
                            zerolinecolor: "#ffffff12",
                            gridcolor: "#ffffff08",
                        },
                    legend: {
                        title: {
                        text: "&nbsp;",
                        font: {
                            color: "#ffffffbb"
                        }
                        },
                        font: {
                            color: "#ffffffbb"
                        }
                    },
                    title: {
                        font: {
                            color: "#ffffffbb"
                        }
                      },
                    modebar: {
                        bgcolor: '#181818',
                        color: "#ffffff88",
                        activecolor: '#fff',
                        orientation: this.screenWidth < 620 ? 'v' : 'h'
                    },
										hoverlabel: {
											bgcolor: 'black',
											bordercolor: 'white',
											font: {
												color: '#fff',
												size: 14
											}
								},
                } ,
                light2d:{
                    'paper_bgcolor': '#f2f2f2',
                    'plot_bgcolor': '#f2f2f2',
                    colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf', "#e0884b","#0080f1","#d35fd3","#29d8d7","#6b9842","#73a9b4","#1c883d","#808080","#4342dd","#e84130"],
                        xaxis: {
                            color: "#00000088",
                            zeroline: true,
                            linecolor: "#00000000",
                            zerolinecolor: "#00000016",
                            gridcolor: "#00000011",
                        },
                        yaxis: {
                            color: "#00000088",
                            zeroline: true,
                            linecolor: "#00000000",
                            zerolinecolor: "#00000016",
                            gridcolor: "#00000011",
                        },
                    legend: {
                        title: {
                        text: "&nbsp;",
                        font: {
                            color: "#444444bb",
                        }
                        },
                        font: {
                            color: "#444444bb"
                        }
                    },
                    title: {
                        font: {
                            color: "#444444"
                        }
                    },
                    modebar: {
                        bgcolor: '#f2f2f2',
                        color: "#777",
                        activecolor: '#111',
                        orientation: this.screenWidth < 620 ? 'v' : 'h'
                    },
										hoverlabel: {
											bgcolor: 'white',
											bordercolor: '#444',
											font: {
												color: '#444',
												size: 14
											}
								}
                } ,
                dark: {
                    'paper_bgcolor': '#181818',
                    dragmode: 'orbit',
                    colorway: ["rgb(76,114,176)", "rgb(221,132,82)", "rgb(85,168,104)", "rgb(196,78,82)", "rgb(129,114,179)", "rgb(147,120,96)", "rgb(218,139,195)", "rgb(140,140,140)", "rgb(204,185,116)", "rgb(100,181,205)", "#e0884b","#0080f1","#d35fd3","#29d8d7","#6b9842","#73a9b4","#1c883d","#808080","#4342dd","#e84130"],
                    scene: {
                        xaxis: {
                            color: "#ffffffaa",
                            tickcolor: "#ffffffaa"
                        },
                        yaxis: {
                            color: "#ffffffaa",
                            tickcolor: "#ffffffaa"
                        },
                        zaxis: {
                            color: "#ffffffaa",
                            tickcolor: "#ffffffaa"
                        },
                    },
                    legend: {
                        title: {
                        text: "&nbsp;<br><br>",
                        font: {
                            color: "#ffffffbb"
                        }
                        },
                        font: {
                            color: "#ffffffbb"
                        }
                    },
                    title: {
                        font: {
                            color: "#ffffffbb"
                        }
                      },
                    modebar: {
                        bgcolor: '#181818',
                        color: "#ffffff88",
                        activecolor: '#fff',
                        orientation: this.screenWidth < 620 ? 'v' : 'h'
                    },
										hoverlabel: {
											bgcolor: 'black',
											bordercolor: 'white',
											font: {
												color: '#fff',
												size: 14
											}
								},
                },
                light: {
                    'paper_bgcolor': '#f2f2f2',
                    dragmode: 'orbit',
                    colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf', "#e0884b","#0080f1","#d35fd3","#29d8d7","#6b9842","#73a9b4","#1c883d","#808080","#4342dd","#e84130"],
                    scene: {
                        xaxis: {
                            color: "#444444",
                            tickcolor: "#444444aa"
                        },
                        yaxis: {
                            color: "#444444",
                            tickcolor: "#444444aa"
                        },
                        zaxis: {
                            color: "#444444",
                            tickcolor: "#444444aa"
                        },
                    },
                    legend: {
                        title: {
                        text: "&nbsp;<br><br>",
                        font: {
                            color: "#444444bb"
                        }
                        },
                        font: {
                            color: "#444444bb"
                        }
                    },
                    title: {
                        font: {
                            color: "#444444"
                        }
                    },
                    modebar: {
                        bgcolor: '#f2f2f2',
                        color: "gray",
                        activecolor: '#444',
                        orientation: this.screenWidth < 620 ? 'v' : 'h'
                    },
										hoverlabel: {
											bgcolor: 'white',
											bordercolor: '#444',
											font: {
												color: '#444',
												size: 14
											}
								}
                }
            }
        };
    },
		Created() {
		},
    mounted() {
    console.log('Plotly started...')
		this.getPlotly().then((res) => {
    console.log('Plotly initialized')
    if ( this.layout && this.mergedLayout) {
        this.prevStyle = this.setstyle || false
        this.lastAnnotated = this.annotations;
        this.mergedLayout.showlegend = this.screenWidth < 620 ? false : true;
        if ( this.mergedLayout.modebar ) this.mergedLayout.modebar.orientation  = this.screenWidth < 620 ? 'v' : 'h'
       if (window.debugGeno) console.log('newPlot', this.mergedLayout)
                let options = this.options || {}
            if (this.modeBarButtons && this.modeBarButtons.length > 0) options.modeBarButtons = this.modeBarButtons
            options.editable = this.editable
            options.displaylogo =  false,
            options.scrollZoom = true
            options.responsive = true;
        Plotly.react(this.$el, this.data, this.mergedLayout, options);
        this.lastmode = this.mode;
        events.forEach(evt => {
            this.$el.on(evt.completeName, evt.handler(this));
        });
        window.PlotlyInstance = Plotly;
        }
			}).catch( (err) => {
				console.log(err)
            this.$store.commit('change', {
                spinner: false
            })
			})
    },
    watch: {
        editable: function() {
            let w = this;
            this.options = this.options ? {...{editable: w['editable']}, ...w['options'] } : { responsive: false, editable: w['editable'], modeBarButtons: w['modeBarButtons'] }
            this.react(0);
            },
        annotations: function(evt) {
        console.log('updated', evt)
            this.react(0);
        },
        theme: function(evt) {
        console.log('updated2', evt)
						//this.downloadTextFile(JSON.stringify(this.data), 'data.json')
						//this.downloadTextFile(JSON.stringify(this.mergedLayout), 'layout.json')
            this.react(0);
            return;
            this.$store.commit('change', {
                spinner: true
            })
            setTimeout(() => {
            this.relayout(this.mergedLayout);
            this.$store.commit('change', {
                spinner: false
            })
            },1)
        },
        annotations2: function() {
            return;
            if ( this.mode === '3d' ) {
            return
            }
            this.$store.commit('change', {
                spinner: true
            })
            setTimeout(() => {
            this.relayout(this.mergedLayout);
            this.$store.commit('change', {
                spinner: false
            })
            },0)
        },
        mesh: function() {
           if ( this.mesh === true && this.data.length === 1 ) {
           let x = this.data[0].x
           let y = this.data[0].y
           let z = this.data[0].z
           this.data.push({ name: 'mesh', alphahull: 7, opacity: 0.05, type: 'mesh3d', x: x, y: y, z: z })
           this.react(300);
           } else if ( this.data.findIndex( x => x.name === 'mesh') >=0 ) {
           this.data.splice(this.data.findIndex( x => x.name === 'mesh'), 1)
           this.react(300);
           }
        },
        setstyle: function() {
            if ( this.setstyle !== this.prevStyle ) {
            let update = this.setstyle
            this.$store.commit('change', {
                spinner: true
            })
            setTimeout(() => {
            this.restyle(this.$el, update);
            this.prevStyle = this.setstyle
            this.$store.commit('change', {
                spinner: false
            })
            }, 300)
            }
        },
        oaptions: {
            handler(value, old) {
            return;
                if (JSON.stringify(value) === JSON.stringify(old)) {
                    return;
                }
                this.schedule({
                    replot: true
                });
            },
            deep: true
        },
        data: {
            handler() {
                this.schedule({
                    replot: true
                });
            },
            deep: true
        },
        layout: {
            handler(layout) {
            //console.log("layout watcher:", layout, this.firstrun, this.redraw, Date.now())
            if ( this.firstrun ) {
            this.firstrun = false;
            this.$store.commit('change', {
                spinner: false
            })
            return;
            }
            let replot = this.lastmode === this.mode && !this.redraw && this.lastAnnotated === this.annotations ? false : true
            console.log('replot', this.redraw, this.lastmode, this.mode, this.lastAnnotated, this.annotations, Date.now())
            console.log((replot ? '' : 'Not ') + 'Replotting...')
            //if ( this.mode === '3d' )  layout.annotations = [];
            this.innerLayout = merge(baseLayout, layout);
            this.schedule({
                replot: replot
            });
        },
        deep: true
        }
    },
    computed: {
        mode: {
            get: function() {
                return this.$store.getters.get('plotMode') ? '3d' : '2d'
            },
            set: function(value) {
                this.$store.commit('change', {
                    plotMode: value
                })
            }
        },
        oaptions: {
          get: function() {
            const optionsFromAttrs = Object.keys(this.$attrs).reduce((acc, key) => {
                acc[camelize(key)] = this.$attrs[key];
                return acc;
            }, {});
            return {
                responsive: false,
                displaylogo: false,
                scrollZoom: true
                //...optionsFromAttrs
            };
            },
            set: function(value) {
            console.log(value);
            this.react(0);
            }
        },
        xflipped: {
            get: function() {
                return this.$store.getters.get('xflipped')
            },
            set: function(value) {
                this.$store.commit('change', {
                    xflipped: value
                })
            }
				},
        yflipped: {
            get: function() {
                return this.$store.getters.get('yflipped')
            },
            set: function(value) {
                this.$store.commit('change', {
                    yflipped: value
                })
            }
				},
						modebarButtons2D() {
            return [[
							{
								name: 'Flip X Axis',
								//icon: this.xflipped ? this.xminusIcon : this.xplusIcon,
								icon: this.xplusIcon,
                class: 'textX',
								click: () => { this.xflipped = !this.xflipped;
                }
							},
							{ 
								name: 'Flip Y Axis',
								icon: this.yflipped ? this.yminusIcon : this.yplusIcon,
								click: () => { this.yflipped = !this.yflipped;
                }
							}, "toImage", "zoom2d", "pan2d", "select2d", "lasso2d", "zoomIn2d", "zoomOut2d", "autoScale2d", "resetScale2d"]]
              },
						modebarButtons3D() { return [[
							{
								name: 'Flip X Axis',
								icon: this.xplusIcon,
								click: () => { this.xflipped = !this.xflipped }
							},
							{ 
								name: 'Flip Y Axis',
								icon: this.yIcon,
								click: () => { this.yflipped = !this.yflipped }
							}, "toImage", "zoom3d", "pan3d", "resetCameraDefault3d", "resetCameraLastSave3d", "hoverClosest3d", "orbitRotation", "tableRotation"]]
              },
        firstrun: {
            get: function() {
                return this.$store.getters.get('pcafirstrun')
            },
            set: function(value) {
                this.$store.commit('change', {
                    pcafirstrun: value
                })
            }
        },
        screenWidth() { return this.$store.getters.get('screenWidth')},
        mergedLayout() {
            let annotations = this.mode === '2d' ? ( this.layout ? this.layout.annotations : [] ) : this.layout && this.layout.scene && this.layout.scene.annotations ? this.layout.scene.annotations : [] 
            let theme = this.theme === 'dark' ? true : false;
            if (annotations.length > 0) {
                annotations.map(x => {
                    x.arrowcolor = x.target ? ( theme ? '#f2f2f288' : '#0000005d' ) : theme && x.clicked ? "#f2f2f244" : x.clicked ? '#00000044' : theme ? "#f2f2f222" : '#00000022';
                    //x.font = { color: theme ? '#ddd' : '#555' };
                    x.font = {color: theme ? 'white' : '#00000099'}
                    x.bgcolor = ( theme ? '#000000aa' : '#f2f2f2aa' );
                    x.bordercolor = x.target ? (theme ? "#f2f2f855" : '#00000011') :  theme ? "#f2f2f222" : '#00000011';
                    x.padding = "10px"
                })
            }
            if ( this.mode === '2d' && annotations.length > 0 ) {
            this.layout.annotations = annotations 
            } else if (annotations.length > 0) {
            this.layout.scene.annotations = annotations
            }
            if ( this.mode === '2d' ) {
            //return this.layout;
            return merge(this.layout, JSON.parse(JSON.stringify(this.plotlyThemes[this.theme + '2d'])))
            } else {
            if ( this.plotlyThemes[this.theme] ) {
            if (this.redraw || this.annotations !== this.lastAnnotate) {
            return merge(this.layout, JSON.parse(JSON.stringify(this.plotlyThemes[this.theme])))
            } else {
            return merge(this.layout, merge(JSON.parse(JSON.stringify(this.innerLayout)), JSON.parse(JSON.stringify(this.plotlyThemes[this.theme]))))
            }
            } else {
            return this.innerLayout
            }
            }
            }
    },
    beforeDestroy() {
        events.forEach(event => this.$el.removeAllListeners(event.completeName));
        Plotly.purge(this.$el);
    },
    methods: {
        ...methods,
        onResize() {
            return;
            this.$store.commit('change', {
                spinner: true
            })
            setTimeout(() => {
            //Plotly.Plots.resize(this.$el);
            this.$store.commit('change', {
                spinner: false
            })
            },100)
        },
downloadTextFile: function(text, name) {
  const a = document.createElement('a');
  const type = name.split(".").pop();
  a.href = URL.createObjectURL( new Blob([text], { type:`text/${type === "txt" ? "plain" : type}` }) );
  a.download = name;
  a.click();
},
        schedule(context) {
            const {
                scheduled
            } = this;
            if (scheduled) {
                //console.log('new');
                scheduled.replot = scheduled.replot || context.replot;
                return;
            }
            this.scheduled = context;
            this.$nextTick(() => {
                const {
                    scheduled: {
                        replot
                    }
                } = this;
                this.scheduled = null;
                if (replot) {
                if (window.debugGeno) console.log('new react', Date.now());
                    this.react();
                    return;
                }
            /*
            this.$store.commit('change', {
                spinner: true
            })
            setTimeout(() => {
                this.mergedLayout.showlegend = this.screenWidth < 620 ? false : true;
                if ( this.mergedLayout.modebar ) this.mergedLayout.modebar.orientation  = this.screenWidth < 620 ? 'v' : 'h'
                //this.mergedLayout.title.font.size  = this.screenWidth < 620 ? '12px' : '16px'
                this.relayout(this.mergedLayout);
                this.$store.commit('change', {
                    spinner: false
                })
                }, 0)
            */
            });
        },
        toImage(options) {
            const allOptions = Object.assign(this.getPrintOptions(), options);
            return Plotly.toImage(this.$el, allOptions);
        },
        downloadImage(options) {
            const filename = `plot--${new Date().toISOString()}`;
            const allOptions = Object.assign(this.getPrintOptions(), {
                filename
            }, options);
            return Plotly.downloadImage(this.$el, allOptions);
        },
        getPrintOptions() {
            const {
                $el
            } = this;
            return {
                format: "png",
                width: $el.clientWidth,
                height: $el.clientHeight
            };
        },
        react(timeout) {
            timeout = timeout >= 0 ? timeout :300
            this.$store.commit('change', {
                spinner: true
            })
            setTimeout(() => {
                this.mergedLayout.showlegend = this.screenWidth < 620 ? false : true;
                let options = this.options || {}
            if (this.modeBarButtons && this.modeBarButtons.length > 0) options.modeBarButtons = this.modeBarButtons
            options.editable = this.editable;
            options.displaylogo =  false,
            options.scrollZoom = true
            options.responsive = true;
  
        if ( this.mergedLayout.modebar ) this.mergedLayout.modebar.orientation  = this.screenWidth < 620 ? 'v' : 'h'
            if ( this.mode === '2d' ) {
            Plotly.react(this.$el, this.data, this.mergedLayout, options);
            this.lastmode = this.mode;
        this.lastAnnotated = this.annotations;
            //Plotly.newPlot(this.$el, this.data, this.mergedLayout, this.options);
            } else {
            Plotly.react(this.$el, this.data, merge(this.mergedLayout, this.scene), options);
            this.lastmode = this.mode;
        this.lastAnnotated = this.annotations;
            }
            this.$store.commit('change', {
                spinner: false
            })
            }, timeout)
        },
				getPlotly: () => {
					 return new Promise((resolve, reject) => {
					 if ( !window.Plotly ) {
					 let script = document.createElement('script')
					 script.onload = () => { 
           console.log('got version 2.18')
					 resolve(true) 
					 }
					 script.async = true
           //script.src = 'https://cdn.plot.ly/plotly-gl3d-latest.min.js'
					 //script.src = 'https://cdn.plot.ly/plotly-latest.min.js'
					 script.src = 'https://cdn.plot.ly/plotly-2.18.0.min.js'
					 document.head.appendChild(script)
						} else {
					 resolve(true) 
						}
						})
				 }
    }
};
</script>
<style>
</style>
